import { render, staticRenderFns } from "./EmpleadoPrestamos.vue?vue&type=template&id=7ee21cc4&"
import script from "./EmpleadoPrestamos.vue?vue&type=script&lang=js&"
export * from "./EmpleadoPrestamos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports